// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__omWdu","btnOutline":"Button_btnOutline__vmzC+"};